import App from 'app/app.js';

function LtScrollableCtrl($scope, $timeout) {
  this.init = function () {
    $timeout(function () {
      $('#sticky-float').stickyfloat({
        duration: 0,
        offsetY: 0,
        parent: $('#auto-scroll')
      });
    });
  };
}

App.controller('LtScrollableCtrl', ['$scope', '$timeout', LtScrollableCtrl]);
